import React, { useState } from 'react';
import { Notification, Table } from 'react-bulma-components';
import { useFirebase } from '../Firebase';
import StoryRow from './row';
import { Story } from './types';

type Props = {
  stories: Story[];
};

const StoriesTable = function StoresTable({ stories }: Props) {
  const firebase = useFirebase()!;
  const [notificationMessage, setNotificationMessage] = useState<string | null>(
    null
  );

  const deleteStory = async (id: string) => {
    const ref = firebase.db.collection('stories2.0').doc(id);
    await ref.delete();
  };

  const onDelete = async (id: string) => {
    // eslint-disable-next-line no-alert
    if (window.confirm(`You are about to delete a Videos Set: ${id}.`)) {
      try {
        await deleteStory(id);
        window.location.reload();
      } catch (error: any) {
        // console.log('onDelete ERR', error);
        setNotificationMessage(error.message);
      }
    }
  };

  return (
    <>
      {notificationMessage && (
        <Notification color="danger" colorVariant="light">
          <button
            aria-label="close"
            className="delete"
            onClick={() => setNotificationMessage(null)}
            type="button"
          />
          {notificationMessage}
        </Notification>
      )}
      <Table className="is-fullwidth is-hoverable">
        <thead>
          <tr>
            <th>
              <abbr title="Order">#</abbr>
            </th>
            <th>ID</th>
            <th>Thumbnail</th>
            <th>Type</th>
            <th>Published?</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {stories
            .sort((a, b) => (b.id < a.id ? 1 : -1))
            .map((story) => (
              <StoryRow key={story.id} story={story} onDelete={onDelete} />
            ))}
        </tbody>
      </Table>
    </>
  );
};

export default StoriesTable;
